module.exports = __webpack_public_path__ + "img/fietsmerin-video.fe0b70ea.jpg";